export const stepsAccordion = () => {
  const roots = Array.from(document.querySelectorAll('.steps-accordion'));
  if (!roots.length) return;

  const initOne = (root) => {
    const steps = Array.from(root.querySelectorAll('.steps-accordion__step'));
    const panels = Array.from(root.querySelectorAll('.steps-accordion__panel'));

    if (!steps.length || !panels.length) return;

    const getPanelById = (id) =>
      root.querySelector(`.steps-accordion__panel[data-panel="${id}"]`);
    const getStepById = (id) =>
      root.querySelector(`.steps-accordion__step[data-step="${id}"]`);

    const closeAll = () => {
      panels.forEach((p) => (p.hidden = true));
      steps.forEach((s) => {
        const btn = s.querySelector('.step__btn');
        if (btn) btn.setAttribute('aria-expanded', 'false');
        s.classList.remove('is-active');
      });
    };

    const open = (id, { scroll = true } = {}) => {
      const panel = getPanelById(id);
      const step = getStepById(id);
      if (!panel || !step) return;

      closeAll();

      panel.hidden = false;
      step.classList.add('is-active');

      const btn = step.querySelector('.step__btn');
      if (btn) btn.setAttribute('aria-expanded', 'true');

    
    };

    // klik kafelka (step)
    steps.forEach((step) => {
      step.addEventListener('click', (e) => {
        // jeśli klik w element typu link w środku – nie ruszaj (opcjonalne)
        const link = e.target.closest('a');
        if (link) return;

        // jeśli klik w przycisk .step__btn to i tak otworzymy, ale nie dublujemy logiki
        const isBtn = e.target.closest('.step__btn');
        if (isBtn) return;

        const id = step.getAttribute('data-step');
        open(id);
      });

      // klik samego przycisku
      const btn = step.querySelector('.step__btn');
      if (btn) {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation(); // ważne: nie odpalaj też handlera z step
          const id = step.getAttribute('data-step');
          open(id);
        });
      }
    });

    // akcje w panelach: zwiń / prev / next
    panels.forEach((panel) => {
      const id = parseInt(panel.getAttribute('data-panel'), 10);

      const collapse = panel.querySelector('.steps-accordion__collapse');
      if (collapse) {
        collapse.addEventListener('click', () => closeAll());
      }

      const prev = panel.querySelector('[data-prev]');
      if (prev) {
        prev.addEventListener('click', () => {
          const target = id - 1 < 1 ? panels.length : id - 1;
          open(String(target));
        });
      }

      const next = panel.querySelector('[data-next]');
      if (next) {
        next.addEventListener('click', () => {
          const target = id + 1 > panels.length ? 1 : id + 1;
          open(String(target));
        });
      }
    });

    // startowo: wszystko zamknięte
    closeAll();
  };

  roots.forEach(initOne);
};